import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgBustCourtDecision(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M60.13 10c7.64 0 13.725 7.18 13.725 15.892v4.252l1.791 5.211c1.934 5.624-.712 12.039-5.835 13.742l-9.542 3.171a.443.443 0 0 1-.298-.007L48.48 47.805c-2.774-1.075-4.36-4.337-3.806-7.56l1.73-10.062v-4.291C46.405 17.18 52.49 10 60.13 10Z"
        fill="#0F172A"
      />
      <path d="M62.89 39.515v5.62a2.643 2.643 0 1 1-5.287 0v-5.62h5.287Z" fill="#A6DBCB" />
      <path
        d="M59.982 15.022s3.974 9.93 9.096 11.642c.39-.39.908-.629 1.477-.629 1.217 0 2.203 1.085 2.203 2.423s-.986 2.423-2.203 2.423a2.04 2.04 0 0 1-.21-.012l-.002.012c-.98 6.032-5.246 10.573-10.36 10.573-5.116 0-9.382-4.54-10.362-10.573l-.001-.014c-1.108-.127-1.972-1.156-1.972-2.409 0-1.338.986-2.423 2.202-2.423 5.813 0 10.129-11.004 10.132-11.013Z"
        fill="#A6DBCB"
      />
      <path
        d="M57.559 40.95c1.322.328 3.965.328 5.286 0v2.442c-2.114 0-4.229-.857-5.286-2.443Z"
        fill="#80CCB5"
      />
      <path
        d="M60.202 31.322c.883 0 1.633.564 1.911 1.35a.441.441 0 1 1-.83.294 1.147 1.147 0 0 0-2.16 0 .441.441 0 0 1-.832-.294 2.027 2.027 0 0 1 1.911-1.35ZM56.149 35.727a.441.441 0 0 1 .617-.089c.462.347 1.322.724 2.341.947 1.014.222 2.131.279 3.103.036a.44.44 0 0 1 .214.855c-1.143.286-2.405.21-3.505-.03-1.095-.24-2.086-.655-2.681-1.102a.441.441 0 0 1-.089-.617Z"
        fill="#0F172A"
      />
      <path
        d="M65.397 46.564h-10.39A21.145 21.145 0 0 0 34.675 61.9l-4.266 14.93c-.964 3.377 1.571 6.738 5.083 6.738h49.42c3.512 0 6.048-3.361 5.083-6.738L85.729 61.9a21.145 21.145 0 0 0-20.332-15.336Z"
        fill="#007A5F"
      />
      <path
        d="M56.237 46.564c0-.73.592-1.322 1.322-1.322h5.286c.73 0 1.322.592 1.322 1.322 0 .953-.337 1.828-.898 2.512.285.332.49.74.582 1.2l1.586 7.929a2.643 2.643 0 0 1-5.183 1.036l-.052-.256-.051.256a2.643 2.643 0 1 1-5.184-1.036l1.586-7.93c.092-.46.298-.867.582-1.199a3.949 3.949 0 0 1-.898-2.512Z"
        fill="#fff"
      />
      <path
        d="M59.762 56.608v-6.872a.44.44 0 0 1 .88 0v6.872a.44.44 0 0 1-.88 0ZM51.172 52.784c0 6.783-5.821 12.282-13.002 12.282-7.181 0-13.003-5.499-13.003-12.282-5.2-11.696 6.342-15.23 13.003-12.282 7.18 0 13.002 5.499 13.002 12.282Z"
        fill="#0F172A"
      />
      <path d="M41.128 67.01v5.62a2.643 2.643 0 0 1-5.287 0v-5.62h5.287Z" fill="#80CCB5" />
      <path
        d="M50.749 53.906a2.499 2.499 0 0 0-2.564-1.218c-4.767-1.097-6.088-4.18-7.85-7.005-7.977 0-8.3.66-11.9 6.977a2.498 2.498 0 0 0-1.388 4.658c.265.153.57.266.89.34 1.491 6.121 5.133 10.666 10.365 10.666 5.217 0 8.853-4.517 10.353-10.611a3.426 3.426 0 0 0 1.18-.395 2.498 2.498 0 0 0 .914-3.412Z"
        fill="#80CCB5"
      />
      <path
        d="M35.797 67.885c1.322.329 3.965.329 5.287 0v2.443c-2.115 0-4.23-.857-5.287-2.443Z"
        fill="#5BBDA0"
      />
      <path
        d="M38 57.753c.882 0 1.632.565 1.91 1.351a.441.441 0 0 1-.83.294 1.147 1.147 0 0 0-2.16 0 .441.441 0 0 1-.831-.294 2.027 2.027 0 0 1 1.91-1.35ZM33.947 60.573a.441.441 0 0 1 .616-.089c.462.347 1.322.724 2.341.947 1.015.222 2.132.279 3.103.036a.44.44 0 0 1 .214.855c-1.143.286-2.405.21-3.505-.03-1.095-.24-2.085-.656-2.68-1.102a.441.441 0 0 1-.09-.617Z"
        fill="#0F172A"
      />
      <path
        d="M43.462 72.996h-10.66a21.144 21.144 0 0 0-20.33 15.336L8.207 103.26c-.965 3.377 1.57 6.739 5.082 6.739h49.686c3.512 0 6.047-3.362 5.083-6.739l-4.266-14.93a21.144 21.144 0 0 0-20.33-15.335Z"
        fill="#599F40"
      />
      <path
        d="M32.251 108.876c0-3.513 1.789-6.609 4.503-8.426a9.101 9.101 0 0 0-3.49-.692H22.627c-2.362 0-4.246.928-5.933 3.097a.507.507 0 0 1-.8-.622c1.742-2.24 3.755-3.345 6.226-3.476V89.12a.507.507 0 0 1 1.013 0v9.625h10.132c1.64 0 3.189.39 4.56 1.082a10.092 10.092 0 0 1 4.56-1.082h10.131V89.12a.507.507 0 0 1 1.014 0v9.638c2.47.13 4.484 1.237 6.226 3.476a.507.507 0 0 1-.8.622c-1.687-2.169-3.572-3.097-5.933-3.097H42.383a9.116 9.116 0 0 0-9.119 9.118.507.507 0 1 1-1.013 0ZM14.603 96.218l3.04.507a.507.507 0 0 1-.167 1l-3.04-.507a.507.507 0 0 1 .167-1Zm2.73-9.579a.507.507 0 0 1 .68.227l1.52 3.04a.507.507 0 0 1-.907.453l-1.52-3.04a.507.507 0 0 1 .226-.68Z"
        fill="#0F172A"
      />
      <path
        d="M22.45 88.855v10.132h11.145c1.52 0 4.053 1.013 4.053 1.013s2.533-1.013 4.052-1.013h11.146V88.855c-6.805 10.132-23.592 10.132-30.397 0Z"
        fill="#78B441"
        style={{
          mixBlendMode: 'multiply',
        }}
        opacity={0.33}
      />
      <path d="M22.625 99.25V89.12c1.013 4.053 2.533 8.105 3.546 10.132h-3.546Z" fill="#0F172A" />
      <path
        d="M26.172 99.758a.506.506 0 0 0 .452-.733c-.993-1.987-2.501-6.004-3.508-10.03a.506.506 0 0 0-.998.124V99.25c0 .28.227.507.507.507h3.547Zm-3.04-6.997c.74 2.353 1.56 4.494 2.239 5.983h-2.239v-5.983Z"
        fill="#0F172A"
      />
      <path
        d="M62.982 110H13.634c-3.37 0-5.84-3.018-5.172-6.167l1.341 2.569h57.01l1.342-2.569c.667 3.149-1.802 6.167-5.173 6.167Z"
        fill="#78B441"
        style={{
          mixBlendMode: 'multiply',
        }}
        opacity={0.33}
      />
      <path
        d="M34.035 72.996c0-.73.591-1.322 1.321-1.322h5.287c.73 0 1.321.592 1.321 1.322a3.95 3.95 0 0 1-.897 2.512c.284.332.49.74.582 1.199l1.585 7.93a2.643 2.643 0 1 1-5.183 1.036l-.052-.257-.05.257a2.643 2.643 0 0 1-5.184-1.037l1.585-7.93a2.63 2.63 0 0 1 .582-1.198 3.95 3.95 0 0 1-.897-2.512Z"
        fill="#fff"
      />
      <path
        d="M37.559 83.04v-6.873a.44.44 0 1 1 .881 0v6.873a.44.44 0 1 1-.881 0ZM43.462 72.555a21.582 21.582 0 0 1 16.85 8.095.44.44 0 1 1-.687.55 20.702 20.702 0 0 0-16.163-7.764.44.44 0 1 1 0-.88ZM53.022 99.25V89.12c-1.014 4.053-2.533 8.105-3.547 10.132h3.547Z"
        fill="#0F172A"
      />
      <path
        d="M49.475 99.758a.506.506 0 0 1-.453-.733c.994-1.987 2.502-6.004 3.508-10.03a.506.506 0 0 1 .998.124V99.25c0 .28-.227.507-.506.507h-3.547Zm3.04-6.997c-.741 2.353-1.56 4.494-2.239 5.983h2.239v-5.983ZM72.317 44.802a8.81 8.81 0 0 1 8.81-8.81h3.525a8.81 8.81 0 0 1 8.81 8.81v7.93H72.318v-7.93Z"
        fill="#0F172A"
      />
      <path d="M80.687 66.828h5.287v6.168h-5.287v-6.168Z" fill="#80CCB5" />
      <path
        d="M92.943 52.507c-.435-.759-.955-1.877-1.45-3.476-.188-.607-.89-3.53-.89-3.53H75.517l-.005.023s-.54 2.392-.885 3.507c-.489 1.579-1.002 2.69-1.434 3.447a2.498 2.498 0 0 0-1.388 4.659c.264.153.57.266.889.339 1.492 6.122 5.134 10.666 10.366 10.666 5.216 0 8.852-4.517 10.353-10.61a3.426 3.426 0 0 0 1.179-.395 2.498 2.498 0 0 0-1.65-4.63Z"
        fill="#A6DBCB"
      />
      <path
        d="M80.705 67.71c1.321.328 3.965.328 5.286 0v2.442c-2.114 0-4.229-.857-5.286-2.443Z"
        fill="#5BBDA0"
      />
      <path
        d="M82.933 57.753c.883 0 1.633.565 1.911 1.351a.441.441 0 1 1-.83.294 1.147 1.147 0 0 0-2.16 0 .441.441 0 0 1-.832-.294 2.027 2.027 0 0 1 1.911-1.35ZM78.88 62.159a.441.441 0 0 1 .617-.089c.462.346 1.322.724 2.341.947 1.015.221 2.132.278 3.103.036a.44.44 0 0 1 .214.855c-1.143.286-2.405.21-3.505-.03-1.095-.24-2.085-.656-2.681-1.102a.441.441 0 0 1-.089-.617Z"
        fill="#0F172A"
      />
      <path
        d="M87.867 72.996h-10.66a21.144 21.144 0 0 0-20.33 15.336l-4.265 14.929c-.965 3.377 1.57 6.739 5.083 6.739h49.685c3.512 0 6.048-3.362 5.083-6.739l-4.265-14.93a21.145 21.145 0 0 0-20.331-15.335Z"
        fill="#78B441"
      />
      <path
        d="M67.383 88.855v10.132H78.53c1.52 0 4.052 1.013 4.052 1.013s2.534-1.013 4.053-1.013H97.78V88.855c-6.805 10.132-23.592 10.132-30.397 0Z"
        fill="#599F40"
      />
      <path
        d="M77.185 108.876c0-3.513 1.789-6.609 4.503-8.426a9.101 9.101 0 0 0-3.49-.692H67.56c-2.362 0-4.246.928-5.933 3.097a.507.507 0 0 1-.8-.622c1.742-2.24 3.755-3.345 6.226-3.476V89.12a.507.507 0 0 1 1.013 0v9.625h10.132c1.64 0 3.189.39 4.56 1.082a10.092 10.092 0 0 1 4.56-1.082h10.131V89.12a.507.507 0 0 1 1.014 0v9.638c2.471.13 4.484 1.237 6.226 3.476a.507.507 0 0 1-.8.622c-1.687-2.169-3.572-3.097-5.933-3.097H87.317a9.116 9.116 0 0 0-9.119 9.118.507.507 0 0 1-1.013 0ZM59.537 96.218l3.04.507a.507.507 0 0 1-.167 1l-3.04-.507a.507.507 0 0 1 .167-1Zm46.441 0a.507.507 0 0 1 .167 1l-3.039.507a.508.508 0 0 1-.167-1l3.039-.507Zm-43.712-9.579a.507.507 0 0 1 .68.227l1.52 3.04a.507.507 0 0 1-.906.453l-1.52-3.04a.507.507 0 0 1 .226-.68Z"
        fill="#0F172A"
      />
      <path d="M67.56 99.25V89.12c1.012 4.053 2.532 8.105 3.545 10.132H67.56Z" fill="#0F172A" />
      <path
        d="M71.106 99.758a.507.507 0 0 0 .452-.733c-.993-1.987-2.501-6.004-3.508-10.03a.506.506 0 0 0-.998.124V99.25c0 .28.227.507.507.507h3.547Zm-3.04-6.997c.74 2.353 1.56 4.494 2.239 5.983h-2.24v-5.983Z"
        fill="#0F172A"
      />
      <path
        d="M107.035 110H57.687c-3.37 0-5.84-3.018-5.172-6.167a4.784 4.784 0 0 0 4.24 2.569h51.212c1.782 0 3.416-.99 4.241-2.569.667 3.149-1.803 6.167-5.173 6.167Z"
        fill="#599F40"
      />
      <path
        d="M78.969 72.996c0-.73.591-1.322 1.321-1.322h5.287c.73 0 1.321.592 1.321 1.322 0 .953-.336 1.828-.897 2.512.284.332.49.74.582 1.199l1.585 7.93a2.643 2.643 0 0 1-5.183 1.036l-.052-.257-.05.257a2.643 2.643 0 1 1-5.185-1.037l1.586-7.93c.092-.458.298-.866.582-1.198a3.949 3.949 0 0 1-.897-2.512Z"
        fill="#fff"
      />
      <path
        d="M82.493 83.04v-6.873a.44.44 0 1 1 .88 0v6.873a.44.44 0 0 1-.88 0ZM97.956 99.25V89.12c-1.014 4.053-2.533 8.105-3.547 10.132h3.547Z"
        fill="#0F172A"
      />
      <path
        d="M94.409 99.758a.507.507 0 0 1-.453-.733c.994-1.987 2.502-6.004 3.508-10.03a.506.506 0 0 1 .998.124V99.25c0 .28-.227.507-.506.507h-3.547Zm3.04-6.997c-.741 2.353-1.56 4.494-2.239 5.983h2.239v-5.983Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgBustCourtDecision)
